export const LifeSafer = "lifesafer";
export const Monitech = "monitechiid";
export const Guardian = "guardianinterlock";
export const QuickStart = "quickstartaz";
